import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { fetchViewData } from "../store/slices/viewSlice";
import { IProductColor, IViewImage } from "../interfaces/IProduct";
import { IView } from "../interfaces/IView";
import Canvas from "./common/Canvas";
import { useParams } from "react-router-dom";
import AutosaveNotification from "./common/AutosaveNotification";
import { hasAutosavedState } from "../services/autosave.service";

function Views() {
  const dispatch = useAppDispatch();
  const params = useParams();
  const viewData = useAppSelector(
    (state: any) => state.canvases.original_view_data
  );
  const [showNotification, setShowNotification] = useState(false);

  useEffect(() => {
    dispatch(fetchViewData({ id: params.productId, podId: params.designId }));
    
    // Check if there's an autosaved design to show notification
    setShowNotification(hasAutosavedState() && window.location.pathname.includes('start-designing'));
  }, []);

  const selectedColor: IProductColor = useAppSelector(
    (state: any) => state.product.selected_color
  );

  const getViewImage: any = (viewId: string) => {
    let viewInfo: IViewImage | null = null;
    for (let index = 0; index < selectedColor.views.length; index++) {
      const view = selectedColor.views[index];
      if (view.id === viewId) {
        viewInfo = view;
      }
    }

    return viewInfo?.img;
  };

  return (
    <>
      <div className="view-editor-area">
        {viewData &&
          viewData.length &&
          viewData.map((view: IView, index: any) => {
            return (
              <Canvas
                design={view.design}
                key={index}
                canvasLeft={view.left}
                canvasTop={view.top}
                canvasId={view.id}
                width={view.width}
                height={view.height}
                productImage={!selectedColor ? view.img : getViewImage(view.id)}
                productImageHeight={view.productImageHeight}
                productImageWidth={view.productImageWidth}
              ></Canvas>
            );
          })}
      </div>
      
      {showNotification && (
        <AutosaveNotification onClose={() => setShowNotification(false)} />
      )}
    </>
  );
}

export default Views;
